<template>
  <CContainer fluid>
    <CRow alignHorizontal="between">
      <div class="row-card-title left">
        <div>
          <div class="card-title-active">Progress</div>
          <div class="line" />
        </div>
      </div>
    </CRow>
    <CRow>
      <div class="main-card">
        <CContainer fluid>
          <CRow>
            <CCol>
              <CChartBar
                :datasets="defaultDatasets"
                :labels="['Topic1', 'Topic2', 'Topic3', 'Topic4', 'Topic5', 'Topic6', 'Topic7', 'Topic8', 'Topic9', 'Topic10']"
              />
            </CCol>
          </CRow>
        </CContainer>
      </div>
    </CRow>
  </CContainer>
</template>

<script>
import { CChartBar } from "@coreui/vue-chartjs";

export default {
  name: "progressCourseOverview",
  components: {
    CChartBar
  },
  computed: {
    defaultDatasets() {
      return [
        {
          label: "MDL",
          backgroundColor: "#FF693A",
          data: [40, 20, 12, 39, 25, 40, 39, 80, 40, 20]
        },
        {
          label: "MFU",
          backgroundColor: "#FFB49C",
          data: [40, 20, 12, 39, 25, 40, 39, 80, 40, 20]
        }
      ];
    }
  }
};
</script>
